import React, { useEffect, useState } from "react";
import { Segment, Header, Grid, Label, Statistic, Table, Divider, Form, DropdownProps, Button } from "semantic-ui-react";

import TemplateMain from "../../components/TemplateMain";
import AgentPerformanceRepository, { IAgentePerformanceResponse } from "../../Repositories/AgentPerformanceRepository";
import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";

import { toast } from "react-toastify";
import NumberFormat from "../../Utils/NumberFormat";
import { GetUser } from "../../services/auth";

interface IState extends IAgentePerformanceResponse {
    loading: boolean;
    year: number;
    month: number;
    apiErrors: IAliancaErrors;
}

const date = new Date();

const initialState: IState = {
    loading: false,
    ganhos: 0,
    debitos: 0,
    cadastros: 0,
    conferidos: 0,
    faltam: 0,
    semVendas: 0,
    devedores: 0,
    perdidos: 0,
    totalPerdidos: 0,
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    apiErrors: { errors: [] }
}

const SummaryMonthGs: React.FC = () => {

    const [state, setState] = useState<IState>(initialState);
    const [loading, setLoading] = useState<boolean>(false);

    const { role } = GetUser();

    const optionsMonth = [
        { key: "1", text: "JANEIRO", value: 1 },
        { key: "2", text: "FEVEREIRO", value: 2 },
        { key: "3", text: "MARÇO", value: 3 },
        { key: "4", text: "ABRIL", value: 4 },
        { key: "5", text: "MAIO", value: 5 },
        { key: "6", text: "JUNHO", value: 6 },
        { key: "7", text: "JULHO", value: 7 },
        { key: "8", text: "AGOSTO", value: 8 },
        { key: "9", text: "SETEMBRO", value: 9 },
        { key: "10", text: "OUTUBRO", value: 10 },
        { key: "11", text: "NOVEMBRO", value: 11 },
        { key: "12", text: "DEZEMBRO", value: 12 }
    ];

    const optionsYear = [
        { key: "1", text: "2020", value: 2020 },
        { key: "2", text: "2021", value: 2021 },
        { key: "3", text: "2022", value: 2022 },
        { key: "4", text: "2023", value: 2023 }
    ];

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const load = async () => {

        setLoading(true);
        try {
            const response = await AgentPerformanceRepository.AgentPerformance({
                year: state.year.toString(),
                month: state.month.toString()
            });

            setState(state => ({
                ...state,
                ganhos: response.ganhos,
                debitos: response.debitos,
                cadastros: response.cadastros,
                conferidos: response.conferidos,
                faltam: response.faltam,
                semVendas: response.semVendas,
                devedores: response.devedores,
                perdidos: response.perdidos,
                totalPerdidos: response.totalPerdidos
            }));

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    };
    useEffect(() => { load() }, []);

    const totalDebitos = state.totalPerdidos + state.debitos;
    const content = (
        <>
            <Header icon="line graph" as="h1" content="Meu Desempenho" dividing />
            <Segment textAlign="center">                
                {
                    role === "Admin" &&
                    <Form widths="equal">
                        <Form.Group>
                            <Form.Field>
                                <Form.Dropdown
                                    required
                                    fluid
                                    selection
                                    search
                                    scrolling
                                    label="Mês"
                                    name="month"
                                    placeholder="Selecione o mês"
                                    options={optionsMonth}
                                    value={state.month}
                                    onChange={onDropdownChange}

                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown
                                    required
                                    fluid
                                    selection
                                    search
                                    scrolling
                                    label="Ano"                                    
                                    name="year"
                                    placeholder="Selecione o ano"
                                    options={optionsYear}
                                    value={state.year}
                                    onChange={onDropdownChange}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group>
                            <Form.Field>
                                <Button
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Atualizar"
                                    onClick={load}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                }
                {
                    role !== "Admin" &&
                    <Form.Group>
                        <Form.Field>
                            <Button
                                fluid
                                icon="search"
                                color="pink"
                                content="Pesquisar"
                                onClick={load}
                            />
                        </Form.Field>
                    </Form.Group>
                }
                <Divider />
                <Segment placeholder>
                    <Grid columns={3} textAlign="center">
                        <Grid.Row>
                            <small>TODOS VALORES SÃO ESTIMADOS, REFERENTE AS CONFERÊNCIAS QUE O PRÓPRIO REPRESENTANTE INSERE NO SISTEMA.</small>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Statistic color="green" size="tiny">
                                    <Statistic.Label content="GANHO (ESTIMADO)"></Statistic.Label>
                                    <Statistic.Value>{NumberFormat.Currency(state.ganhos)}</Statistic.Value>
                                </Statistic>
                            </Grid.Column>
                            <Grid.Column>
                                <Statistic color="red" size="tiny">
                                    <Statistic.Label content="DÉBITO (ESTIMADO)"></Statistic.Label>
                                    <Statistic.Value>{NumberFormat.Currency(totalDebitos)}</Statistic.Value>
                                </Statistic>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Statistic color="teal" size="tiny">
                                    <Statistic.Label content="NOVOS CADASTROS"></Statistic.Label>
                                    <Statistic.Value>{state.cadastros}</Statistic.Value>
                                </Statistic>
                            </Grid.Column>
                            <Grid.Column>
                                <Statistic color="blue" size="tiny">
                                    <Statistic.Label content="KITS CONFERIDOS"></Statistic.Label>
                                    <Statistic.Value>{state.conferidos}</Statistic.Value>
                                </Statistic>
                            </Grid.Column>
                            <Grid.Column>
                                <Statistic color="orange" size="tiny">
                                    <Statistic.Label content="FALTAM CONFERIR"></Statistic.Label>
                                    <Statistic.Value>{state.faltam}</Statistic.Value>
                                </Statistic>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Statistic color="grey" size="tiny">
                                    <Statistic.Label content="KIT'S SEM VENDA"></Statistic.Label>
                                    <Statistic.Value>{state.semVendas}</Statistic.Value>
                                </Statistic>
                            </Grid.Column>
                            <Grid.Column>
                                <Statistic color="red" size="tiny">
                                    <Statistic.Label content="DEVEDORES"></Statistic.Label>
                                    <Statistic.Value>{state.devedores}</Statistic.Value>
                                </Statistic>
                            </Grid.Column>
                            <Grid.Column>
                                <Statistic color="black" size="tiny">
                                    <Statistic.Label content="KIT'S PERDIDOS"></Statistic.Label>
                                    <Statistic.Value>{state.perdidos}</Statistic.Value>
                                </Statistic>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            </Segment>
        </>
    )
    return (
        <TemplateMain
            loading={loading}
            content={content}
        />
    )
};

export default SummaryMonthGs;
